module.exports = __webpack_public_path__ + "static/media/yacine-terai-200x200.9300d3a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/advisors/images/yacine-terai-200x200.jpg
// module id = 1786
// module chunks = 147